import { Link } from 'react-router-dom'

import LogoWhite from 'components/Logo'
import * as S from './styles'
import Input from 'components/Input'
import LargeButton from 'components/LargeButton'
import { useWindowSizeHook } from 'hooks/useWindowHooks'

const ForgotPassword = () => {
  const { width } = useWindowSizeHook()

  return (
    <S.Wrapper>
      {width >= 794 && (
        <S.SideLeft>
          <S.Background>
            <LogoWhite size="small" />

            <S.WrapperMessage>
              <p className="message">
                All your favorite games
                <br /> in one place
              </p>
              <p className="describe">
                WON is the best and most complete gaming platform.
              </p>
            </S.WrapperMessage>
            <p className="footer-message">
              Won Games 2020 © Todos os Direitos Reservados
            </p>
          </S.Background>
        </S.SideLeft>
      )}

      <S.SideRight>
        <LogoWhite size="large" />
        <h3>Forgot Password</h3>
        <Input placeholder="Email" type="email" />

        <LargeButton>Send password</LargeButton>
        <Link className="link signin" to="signup">
          Dont't have an account? Sign up
        </Link>
      </S.SideRight>
    </S.Wrapper>
  )
}

export default ForgotPassword
